<template>
  <v-row class="error-box blue-grey lighten-5">
    <v-col class="py-12 d-md-flex ่text-center justify-center">
      <div class="text-center" v-if="errorStatus">
        <h1 class="error-title error--text">
          {{ errorStatus }}
        </h1>
        <h3 class="text-uppercase error-subtitle">
          {{ errorText }}
        </h3>
        <br />
        <v-btn color="info" @click="goto()">{{ $t("goBackPage") }}</v-btn>
      </div>
      <div class="text-center align-center" v-else>
        <h1 class="error-title error--text">404</h1>
        <h3 class="text-uppercase error-subtitle">{{ $t("pageNotFound") }}</h3>
        <br />
        <v-btn color="info" @click="goToLogin()">{{ $t("goToLogin") }}</v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Error",
  data() {
    return {
      errorStatus: "",
      errorText: "",
    };
  },
  methods: {
    goToLogin() {
      this.$router.push({ name: "check-login" });
    },
    goto() {
      // this.$store.replaceState({});
      this.$router.go(-2);
    },
  },
  created() {
    this.errorStatus = this.$route.query.error_status;
    this.errorText = this.$route.query.text_status;
    if (!this.errorStatus) {
      this.goToLogin();
    }
  },
};
</script>

<style lang="scss">
.error-box {
  height: 100%;
  width: 100%;
  position: fixed;
  background-position: top center;
  background-repeat: no-repeat;
  background: url("../assets/images/background/error-bg.jpg");
}
.error-title {
  font-size: 210px;
  font-weight: 900;
  text-shadow: 4px 4px 0 #fff, 6px 6px 0 #343a40;
  line-height: 210px;
}

@media (max-width: 991px) {
  .error-title {
    font-size: 120px;
    line-height: 120px;
  }
}

@media (max-width: 767px) {
  .error-title {
    font-size: 40px;
    line-height: 40px;
  }
}
</style>
